const doc = [({"en":({"js":({"admin":({"sheet_layouts":({"select":({"choose_sheet_layout":"Choose sheet layout"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;